import { request } from 'src/services/request';
import {
  CategoryDTO,
  ResponseCodeSF,
} from 'src/features/common/types/salesforce/dto/application/category-dto';

interface AppUpdates {
  order_ref_number: string;
  journey_name: 'pos' | 'legacy';
  responses: ResponseCodeSF[];
}

const getUpdateInformation = (
  appUpdates: AppUpdates,
  abortController: AbortController,
): Promise<CategoryDTO[]> => {
  const ENDPOINT = 'pending-app/codes';

  return request(ENDPOINT, {
    fetchOptions: {
      method: 'POST',
      body: JSON.stringify(appUpdates),
      signal: abortController.signal,
    },
  }).then((response) => {
    if (response.status !== 200 || !response.result.updateInfo?.categories) {
      return [];
    }

    return response.result.updateInfo.categories;
  });
};

export const PendingAppService = { getUpdateInformation };
